<template>
    <div class="lms__user_account_security">
        <template v-if="user.isTokenFromSSO()">
            <component-note>You can not change your password or two-factor authentication when logging in using single sign on. <br><br>To manage your security please log in using your password.</component-note>
        </template>
        <template v-else>
            <lms-user-account-security-password/>
            <lms-user-account-security-mfa/>
        </template>
    </div>
</template>

<script>
import LmsUserAccountSecurityPassword from '@/components/lms/user/account/LmsUserAccountSecurityPassword'
import LmsUserAccountSecurityMfa from '@/components/lms/user/account/LmsUserAccountSecurityMfa'
import { User } from '@/User'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'lms-user-account-security',
  components: { ComponentNote, LmsUserAccountSecurityMfa, LmsUserAccountSecurityPassword },
  data () {
    return {
      user: new User()
    }
  },
  mounted () {
    this.$validator.pause()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/account/_lmsuseraccountsecurity.scss";
</style>
